import { PlantLayoutAreaDrawingsThemeSizeConfig } from './types';

const small: PlantLayoutAreaDrawingsThemeSizeConfig = {
  plantLayoutAreaDrawings: {},
};

export default small;
